import { PERMISSION_LEVEL_KEYS, PERMISSIONS_KEY } from "./permissions";

const hidden = true;
const MENU_ITEMS = [
  {
    label: "Dashboard",
    path: "/dashboard",
    permission: PERMISSIONS_KEY.MODELS,
  },
  {
    label: "Models",
    path: "/models",
    permission: PERMISSIONS_KEY.MODELS,
  },
  {
    label: "Reports",
    path: "/reports",
    permission: PERMISSIONS_KEY.REPORTS,
  },
  {
    label: "Quotes",
    path: "/quotes",
    permission: PERMISSIONS_KEY.SALES,
    hidden,
  },
  {
    label: "Schedule",
    path: "/schedule",
    permission: PERMISSIONS_KEY.SCHEDULE,
  },
  {
    label: "Outbound",
    path: "/outbound",
    permission: PERMISSIONS_KEY.OUTBOUND,
  },
  {
    label: "Displays",
    path: "/displays",
    permission: PERMISSIONS_KEY.DISPLAYS,
  },
  {
    label: "Tickets",
    path: "/tickets",
    permission: PERMISSIONS_KEY.TICKETS,
  },
  {
    label: "Work Orders",
    path: "/works",
    permission: PERMISSIONS_KEY.WORK_ORDERS,
    hidden,
  },
  {
    label: "Customers",
    path: "/customers",
    permission: PERMISSIONS_KEY.CUSTOMERS,
    hidden,
  },
  {
    label: "Parts",
    path: "/parts",
    permission: PERMISSIONS_KEY.PARTS,
    access: PERMISSION_LEVEL_KEYS.EDIT,
    hidden,
  },
  {
    label: "Orders",
    path: "/orders",
    permission: PERMISSIONS_KEY.ORDERS,
    hidden,
  },
  {
    label: "Line Items",
    path: "/lineitems",
    permission: PERMISSIONS_KEY.LINE_ITEMS,
    hidden,
  },
  {
    label: "Barcodes",
    path: "/barcodes",
    permission: PERMISSIONS_KEY.BARCODES,
    access: PERMISSION_LEVEL_KEYS.EDIT,
    hidden,
  },
  {
    label: "Shipping",
    path: "/shipping",
    permission: PERMISSIONS_KEY.SHIPMENTS,
    hidden,
  },
  {
    label: "Labor",
    path: "/labor",
    permission: PERMISSIONS_KEY.TICKETS,
    hidden,
  },
  {
    label: "Organization",
    path: "/organization",
    permission: PERMISSIONS_KEY.ORGANIZATION_SETTINGS,
    hidden,
  },
  {
    label: "Users",
    path: "/users",
    permission: PERMISSIONS_KEY.USERS,
    hidden,
  },
  {
    label: "Notifications",
    path: "/notifications",
    hidden,
  },
].map((r, id) => ({ id, ...r }));

export const getUserMenuItems = (permissions = [], includeHidden = true) => {
  const userPermissions = permissions?.length ? permissions : [];

  const ITEMS = includeHidden
    ? MENU_ITEMS
    : MENU_ITEMS?.filter((i) => !i.hidden);

  const FINAL = ITEMS?.filter((menu) => {
    if (!menu.permission) return true;
    const userPermission = userPermissions.find(
      (p) => menu.permission === p.id,
    );
    const value = userPermission?.value || 0;
    const access = menu.access || PERMISSION_LEVEL_KEYS.VIEW_ONLY;
    return value >= access;
  });

  return FINAL;
};
